// KanbanColumn.js
import React from 'react';
import { Box, VStack, Center, Spinner } from '@chakra-ui/react';
import LeadCardWrapper from './LeadCardWrapper';
import { useColorModeValue } from '@chakra-ui/react';

const KanbanColumn = ({ stageId, title, leads, isLoading, onEdit, onAdvancedEdit }) => {
    const columnBg = useColorModeValue('gray.50', 'gray.800');
    const columnBorderColor = useColorModeValue('gray.100', 'gray.700');

  return (
    <Box
      w="100%"
      bg={columnBg}
      borderRadius="xl"
      minH="500px"
      h="100%"
      display="flex"
      flexDirection="column"
    >
      {isLoading ? (
        <Center h="200px">
          <Spinner size="xl" />
        </Center>
      ) : (
        <VStack spacing={2} align="stretch" flex={1} px={1} h="100%" minH="inherit">
          {leads.map((lead, index) => (
            <LeadCardWrapper
              key={lead.leadId}
              lead={lead}
              index={index}
              onEdit={onEdit}
              onAdvancedEdit={onAdvancedEdit}
            />
          ))}
        </VStack>
      )}
    </Box>
  );
};

export default KanbanColumn;